import { apiClient } from "./client";

export interface CheckDeviceResponse {
  authenticated: boolean;
  requiresVerification?: boolean;
  token?: string;
  phoneNumber?: string;
}

export interface SendCodeResponse {
  codeId: string;
  expiresAt: string;
}

export interface VerifyCodeResponse {
  token: string;
  phoneNumber: string;
}

export const authAPI = {
  checkDevice: async (phoneNumber: string): Promise<CheckDeviceResponse> => {
    const { data } = await apiClient.post("/auth/check-device", {
      phoneNumber,
    });
    return data;
  },

  sendCode: async (phoneNumber: string): Promise<SendCodeResponse> => {
    const { data } = await apiClient.post("/auth/send-code", {
      phoneNumber,
    });
    return data;
  },

  verifyCode: async (
    codeId: string,
    code: string,
    name?: string,
  ): Promise<VerifyCodeResponse> => {
    const { data } = await apiClient.post("/auth/verify-code", {
      codeId,
      code,
      name,
    });
    return data;
  },
};
